import { clearLocalStorageBasedOnBodyAttr } from 'root/utils/dom/localStorage';
import AdTrackers from 'root/core/tracking/adTrackingBlockCheck/adTrackingBlockCheck';
import TrackingCookies from 'root/core/tracking/trackingCookies/trackingCookies';
import AnchorsScrolling from 'root/core/anchorsScrolling';
import { handleYoutubeLightboxesOnDocumentClick } from 'root/main/components/mediaLightbox/youtubeLightbox';
import { swapLightboxFormLinksForWizard } from 'root/core/wizardLinkSwapping';
import {
    trackRestaurantProductOnLoadViaDataAttribute,
    trackRestaurantProductInURL,
} from 'root/core/restaurantProductTracking/restaurantProductTracking';
import { setCookieBasedOnKountaParam } from 'root/core/kounta';
import { populateESeriesLinkParams } from 'root/core/eSeriesLinkSwapping';
import { removeEcomFromPCPages } from 'root/core/removeEcomFromPCPages';
import resetTitlesHeightToTallest from 'root/utils/resetTitlesHeightToTallest';
import { populateFootnoteSection } from 'root/core/footnoteSection';
import { toggleDisplayDoNotSellButtonByLocation } from 'root/core/OneTrustControllers';
import sessionTracking from 'root/core/tracking/sessionTracking/sessionTracking';

function CoreDom() {
    TrackingCookies();
    AnchorsScrolling();
    handleYoutubeLightboxesOnDocumentClick();
    swapLightboxFormLinksForWizard();
    trackRestaurantProductOnLoadViaDataAttribute();
    trackRestaurantProductInURL();
    populateESeriesLinkParams();
    removeEcomFromPCPages();
    populateFootnoteSection();
}

function CoreLoad() {
    clearLocalStorageBasedOnBodyAttr();
    AdTrackers();
    setCookieBasedOnKountaParam();
    resetTitlesHeightToTallest();
    toggleDisplayDoNotSellButtonByLocation();
    sessionTracking();
}

function buttonTrackingHandler(e) {
    import(
        /* webpackChunkName: "buttonTracking" */ 'root/core/tracking/buttonTracking/buttonTracking'
    ).then(module => new module.default().sendEventHandler(e));
}

export { CoreDom, CoreLoad, buttonTrackingHandler };
